import optionRenderer from './optionRenderer';

export default optionRenderer;
